import util from "../util/util";

export default function spotFormValidation(report) {
  // returned, defines if we have errors or not;
  let hasErrors = false;

  // returned, used to setState to inform the users of the errors;
  const errors = {};

  if (report.name === ``) {
    errors.name = "Spot Name is a required field.";
    hasErrors = true;
  }

  // if it's a url, make sure it is valid;
  if (report.source === 1 && testForValidUrl(report.sourceUrl) === false) {
    errors.sourceUrl = true;
    hasErrors = true;
  }

  // need new validation with the file change (file won't change);
  if (
    report.source === 2 &&
    (report.sourceFile === `` ||
      report.sourceFile === util.spotFormDefaultSourceFile)
  ) {
    errors.sourceFile = true;
    hasErrors = true;
  }

  // if the file is still uploading;
  if (report.source === 2 && report.showProgressBar) {
    errors.sourceFile = true;
    errors.uploading = true;
    hasErrors = true;
  }

  // if the file is too large;
  if (report.filesize > util.spotFormMaxFilesize) {
    errors.sourceFile = true;
    hasErrors = true;
  }

  return {
    errors: errors, // return for setState to tell the user what went wrong;
    hasErrors: hasErrors // return true/false so the submit works/doesn't;
  };
}

// regex to validate a URL;
function testForValidUrl(url) {
  // eslint-disable-next-line
  const pattern = /^(http|https):\/\/(([a-zA-Z0-9$\-_.+!*'(),;:&=]|%[0-9a-fA-F]{2})+@)?(((25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9]|[1-9][0-9]|[0-9])(\.(25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9]|[1-9][0-9]|[0-9])){3})|localhost|([a-zA-Z0-9\-\u00C0-\u017F]+\.)+([a-zA-Z]{2,}))(:[0-9]+)?(\/(([a-zA-Z0-9$\-_.+!*'(),;:@&=]|%[0-9a-fA-F]{2})*(\/([a-zA-Z0-9$\-_.+!*'(),;:@&=]|%[0-9a-fA-F]{2})*)*)?(\?([a-zA-Z0-9$\-_.+!*'(),;:@&=\/?]|%[0-9a-fA-F]{2})*)?(\#([a-zA-Z0-9$\-_.+!*'(),;:@&=\/?]|%[0-9a-fA-F]{2})*)?)?$/;

  return pattern.test(url);
}
